import { useState, useEffect } from 'react'
import useFetch from './useFetch'

const useRecurrantFetch = (
  url,
  options,
  deps = [],
  predicate = true,
  refreshSeconds = 30,
  errorRefreshSeconds = 5
) => {
  const [nextFetch, setNextFetch] = useState(
    new Date().getTime() + refreshSeconds * 1000
  )
  const [state, { refresh, cancel }] = useFetch(
    url,
    {
      ...options,
      onSuccess: (response) => {
        setNextFetch(new Date().getTime() + refreshSeconds * 1000)
        options.onSuccess && options.onSuccess(response)
      },
      onError: (error) => {
        setNextFetch(new Date().getTime() + errorRefreshSeconds * 1000)
        options.onError && options.onError(error)
      },
    },
    deps,
    predicate
  )

  useEffect(() => {
    if (nextFetch !== Infinity) {
      const waitTime = nextFetch - new Date().getTime()
      if (waitTime > 0) {
        const timeoutHandle = setTimeout(refresh, waitTime)
        return () => clearTimeout(timeoutHandle)
      } else {
        refresh()
      }
    }
  }, [nextFetch, refresh])

  return [
    state,
    {
      refresh: () => setNextFetch(0),
      cancel: () => {
        cancel()
        setNextFetch(Infinity)
      },
    },
  ]
}

export default useRecurrantFetch
